import { observer } from "mobx-react-lite"

import type { ILiquidityPool } from "@/domains/pools/types"
import { MinimalPoolStore } from "@/domains/minimal-pool"
import { TokenStore } from "@/domains/tokens"

import { FarmingRewardsView } from "./farming-rewards-view"
import { NoUniV2Rewards } from "./no-uni-v2-rewards"

export type UniV2RewardsViewProps = {
  governanceToken: TokenStore
  pools: Array<MinimalPoolStore>
  onClaimAllLpRewards: (pools: Array<MinimalPoolStore>) => void
  onClaimUniV2LpReward: (pool: MinimalPoolStore) => void
}

export const UniV2RewardsView = observer(
  ({ governanceToken, pools, onClaimAllLpRewards, onClaimUniV2LpReward }: UniV2RewardsViewProps) => {
    const handleClaimAll = (pools: Array<ILiquidityPool>) => {
      onClaimAllLpRewards(pools as Array<MinimalPoolStore>)
    }

    const handleClaim = (pool: ILiquidityPool) => {
      onClaimUniV2LpReward(pool as MinimalPoolStore)
    }

    return (
      <FarmingRewardsView
        title="Farming"
        description="Rewards earned by staking liquidity positions into Scale farming gauges."
        poolType="V2"
        governanceToken={governanceToken}
        pools={pools}
        onClaimAllLpRewards={handleClaimAll}
        onClaimLpReward={handleClaim}
        emptyState={<NoUniV2Rewards />}
      />
    )
  },
)
